import { CASHFREE_MODE } from "../config/config";

// Dynamically load Cashfree JS SDK
let cashfreePromise: Promise<any> | null = null;

export function loadCashfree(mode: "sandbox" | "production" = "sandbox"): Promise<any> {
  if (cashfreePromise) return cashfreePromise;
  
  cashfreePromise = import("@cashfreepayments/cashfree-js").then(
    ({ load }) => load({ mode })
  );
  return cashfreePromise;
}

// Determine mode from environment
export function getCashfreeMode(): "sandbox" | "production" {
  return CASHFREE_MODE as "sandbox" | "production";
}
